import config from '../config/config';

const Dialog = require('../lib/dialog').default;
const validInputIndicator = require('../validation/valid-input-indicator');

const desktopMQ = window.matchMedia(`(min-width: ${config.BREAKPOINTS.DESKTOP_MIN}px)`);

// where to insert the error message, that html is inside content asset 'newsletter-modal-overlay'
const ERROR_INSERT_BEFORE_SELECTOR = '.newsletter-modal-title';
export const COOKIE_NAME = 'newsletterModalShown'; // identfiy if the newsletter modal has been shown
const COOKIE_DURATION = 28 * 24 * 60 * 60 * 1000; // cookie duration in milliseconds (28 days)
let dialogShown = false;

/**
 * Set cookie popup shown, so for the next 28 days the popup will not be shown
 */
function setCookiePopupShown() {
    const d = new Date();
    d.setTime(d.getTime() + COOKIE_DURATION);
    if (document.cookie.indexOf(COOKIE_NAME) === -1) {
        document.cookie = `${COOKIE_NAME}=1; path=/; expires=${d.toUTCString()}`;
    }
}

/**
 * @param {string} page - where will show (homepage, PDP, CLP)
 * @function initDialog
 */
function initDialog(page) {
    if (dialogShown) {
        return;
    }
    dialogShown = true;
    let url;
    if (page === 'homepage') {
        url = Urls.newsletterModalOverlay;
    } else {
        url = Urls.newsletterModalOverlayCLP;
    }
    const dialog = new Dialog({
        additionalClasses: ['newsletter-modal-overlay'],
        useLegacyContainer: true,
        url,
        canCloseOnBackdropClick: true,
        isModal: true,
        useLegacyBackdrop: true,
        hasCloseText: false,
        /**
         *
         */
        callback: () => {
            $('body').addClass('overflow-hidden');
            $('.dialog-content').append(
                '<button class="ui-dialog-titlebar-close"><span class="icon icon-icon-menu-close"></span></button>'
            );
            $('.ui-dialog-titlebar-close').on('click', event => {
                event.preventDefault();
                closeNewsletterPopup();
            });
            initEvents();
        },
        /**
         *
         */
        closeCallback: () => {
            closeNewsletterPopup();
        }
    });
    dialog.open();
}

/**
 * Close the newsletter popup
 */
function closeNewsletterPopup() {
    $('.ui-dialog').remove();
    $('body').removeClass('overflow-hidden');
    setCookiePopupShown();
}

/**
 * Highlight the terms error
 *
 * @param {jQuery} $newsletterContainer - The newsletter container
 * @function highlightTermsError
 * @returns {void}
 */
const highlightTermsError = $newsletterContainer => {
    const $acceptTerms = $newsletterContainer.find('.accept-terms');
    $acceptTerms.find('.custom-checkbox-container').addClass('error');
    $acceptTerms.find('.checkbox-input').one('click', e => {
        $newsletterContainer
            .parent()
            .find('.status')
            .fadeOut(300, () => $(e.currentTarget).siblings('.custom-checkbox-container').removeClass('error'));
    });
};

/**
 * Clear form errors
 *
 * @param {jQuery} $flyinContainer - The flyin container
 * @param {jQuery} $newletterForm - The newsletter container
 * @function clearErrors
 * @returns {void}
 */
function clearErrors($flyinContainer, $newletterForm) {
    $flyinContainer.find('.status.message').remove();
    const $acceptTerms = $newletterForm.find('.accept-terms');
    $acceptTerms.find('.custom-checkbox-container').removeClass('error');
}

/**
 * Initialize events when newsletter form is opened
 *
 * @function initEvents
 */
function initEvents() {
    const $flyinContainer = $('#dialog-container');
    const $newletterForm = $flyinContainer.find('.js-newsletter-form');
    const $newsletterModal = $('.newsletter-modal-overlay');
    const $acceptTerms = $newletterForm.find('.accept-terms');

    $acceptTerms.on('change', () => {
        clearErrors($flyinContainer, $newletterForm);
    });

    $newletterForm.on('submit', event => {
        event.preventDefault();
    });

    $newsletterModal.find('.close-button').on('click', function (event) {
        event.preventDefault();
        closeNewsletterPopup();
    });

    validInputIndicator.initValidIndicatorEvent({container: $flyinContainer});

    const $subscribeButton = $newletterForm.find('.js-btn-newsletter-subscribe');

    $newsletterModal.trigger('focus');

    $subscribeButton.on('click', event => {
        event.preventDefault();

        clearErrors($flyinContainer, $newletterForm);

        if (!$newletterForm.valid()) {
            return false;
        }

        const url = $newletterForm.attr('action');

        $.ajax({
            url,
            type: 'POST',
            dataType: 'json',
            data: $newletterForm.serialize(),
            /**
             * ajax success
             *
             * @param {Object} response - response from server
             */
            success: response => {
                // eslint-disable-next-line no-constant-condition
                if (response.success) {
                    $('.newsletter-modal-step1').hide();
                    $('.newsletter-modal-step2').show();
                    setCookiePopupShown();
                } else if (response.valueError) {
                    $(`<div class="status message error-form">${response.valueError}</div>`).insertBefore(
                        $flyinContainer.find(ERROR_INSERT_BEFORE_SELECTOR)
                    );

                    if (response.termsError) {
                        highlightTermsError($newletterForm);
                    }
                }
            }
        });
    });
}

/**
 * Init newsleter popup for PDP and CLP pages
 */
function initCLPandPDP() {
    $(document).on('mouseleave', function (e) {
        if (document.cookie.indexOf(COOKIE_NAME) === -1 && e.clientY < 0) {
            initDialog('clp_pdp');
        }
    });
}

/**
 * @module NewsletterPopup
 * @description This module is responsible for displaying the newsletter popup.
 */
export const NewsletterPopup = {
    /**
     * Init newsleter popup for homepage for desktop and mobile
     */
    initHomepage() {
        initDialog('homepage');
    },
    /**
     * Init newsleter popup for PDP and CLP pages for desktop
     */
    initCLPandPDP() {
        if (SitePreferences.NEWSLETTER_POPUP_ENABLED && desktopMQ.matches) {
            initCLPandPDP();
        }
    },
    /**
     * Init newsleter popup on fast scroll on mobile
     */
    initOnFastScroll() {
        if (
            SitePreferences.NEWSLETTER_POPUP_ENABLED &&
            !desktopMQ.matches &&
            document.cookie.indexOf(COOKIE_NAME) === -1
        ) {
            initDialog('clp_pdp');
        }
    }
};
